import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

const fetchWorkItemsFromSOW = async (sowID: string, date?: Date) => {
  const { data } = await apiInputService.get(
    `/workItem/profile/SOW/requestParam/${sowID}`,
  );

  return data;
};

export const useWorkItemsFromSOW = (
  sowID: string,
  date?: Date,
  options?: any
) => {
  return useQuery<any[]>(
    ["work-items-sow", sowID, date ? date.toLocaleDateString() : "none"],
    () => fetchWorkItemsFromSOW(sowID, date),
    {
      enabled: Boolean(sowID),
      ...options,
    }
  );
};
